import templateUrl from 'servicestack/auto-query/auto-query-views.htm'

let Views = {
    bindings: {
        query: '<'
    },
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}


export default Views;